<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { ref, computed, watch } from 'vue'
import BaseModal from '@/components/BaseModal/index.vue'

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  item: { type: Object, default: null },
})

const emit = defineEmits(['update:modelValue', 'confirm'])

const currentItem = ref(null)

/** Options 1..N driven by cart item's max_quantity from API */
const quantityOptions = computed(() => {
  const item = currentItem.value || props.item
  const max = item?.max_quantity ?? 99
  const count = Math.max(1, Number(max) || 1)
  const list = []
  for (let i = 1; i <= count; i++) {
    list.push(i)
  }
  return list
})

const selectedQty = computed(() => {
  const item = currentItem.value || props.item
  return item ? (item.quantity ?? item.amount ?? 1) : 1
})

watch(() => props.modelValue, (visible) => {
  if (visible && props.item) {
    currentItem.value = props.item
  } else {
    currentItem.value = null
  }
})

watch(() => props.item, (item) => {
  currentItem.value = item || null
}, { immediate: true })

function selectQuantity(n) {
  const item = currentItem.value || props.item
  if (item && n !== (item.quantity ?? item.amount)) {
    emit('confirm', { item, amount: n })
  }
  emit('update:modelValue', false)
}
</script>
